<template lang='pug'>
  div
    //Button link
    app-icon-btn(
      :disabled="this.disabled"
      @click.native="showModal",
      data-kind="link",
      data-icon="fa-solid fa-square-check",
      :data-label="$I18n.t('vue.order_reactivate.title')"
    )
    app-modal(
      :showing="controls.modal.showing",
      @showing="controls.modal.showing = $event"
    )
      template(#header)
        p {{ labels.modal_title }}
      template(#body)
        // Spinner Loading
        div(v-if="state.sending" class="tw-text-center tw-my-20")
          div(class="spinner-border spinner-border-sm" role="status")
        // FORM
        div(v-else)
          p {{$I18n.t('vue.order_reactivate.confirmation_message')}}
          p(class="text-info") {{$I18n.t('vue.order_reactivate.warning_order_reactivate')}}
      template(#footer)
        .app-buttons-row.justify-end(v-if="!state.sending")
          app-icon-btn(
            data-kind="link",
            @click.native="cancel",
            data-icon="fa-solid fa-square-xmark",
            :data-label="labels.cancel_btn"
          )
          app-icon-btn(
            data-kind="btn",
            @click.native="send",
            data-icon="fa-solid fa-square-check",
            :data-label="labels.send_btn"
          )
</template>

<script>
import CoreComponents from "../core";
import BackendService from '../../services/backend_service';
const { ProcessingMixin } = require("../../mixins");

export default {
  mixins: [ProcessingMixin],
  components: {
    "app-icon-btn": CoreComponents.AppIconBtn,
    "app-modal": CoreComponents.Modal,
  },
  props:['dataOrder', 'disabled'],
  data: function () {
    return {
      record: {
        order: this.dataOrder
      },
      controls: {
        modal: {
          showing: false,
        },
      },
      state: {
        sending: false,
      },
      labels: {
        modal_title: this.$I18n.t('vue.order_reactivate.title'),
        cancel_btn: this.$I18n.t('vue.order_reactivate.btn_cancel'),
        send_btn: this.$I18n.t('vue.order_reactivate.btn_send'),
      },
    };
  },
  methods: {
    showModal: function () {
      this.controls.modal.showing = true;
    },
    hideModal: function () {
      this.controls.modal.showing = false;
    },
    cancel: function () {
      this.hideModal();
    },
    send: function () {
      let self = this;
      self.state.sending = true;
      BackendService
        .reactivate_order(this.record.order.id)
        .then(_=>{
          this.hideModal();
          location.reload();
        })
        .catch(error => {
          console.error('Error reactivating order:', error);
          self.state.sending = false;
        });
    },
  },
};
</script>
